<div class="product-details-container">
  <div class="row">
    <div class="col">
      <h1>{{ product$ ?  (product$ | async)?.name: 'TITLE UNDEFINED'}}</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <img src="{{ product$ ?  (product$ | async)?.image: 'https://via.placeholder.com/544x364' }}">
    </div>
    <div class="col-lg-6">
      <div [innerHtml]="(product$ ?  (product$ | async)?.longDescription: 'LONG DESC UNDEFINED')"></div>
      <div class="price-box">
        <modeso-product-price [price]=" product$ ?  (product$ | async)?.price : 'PRICE UNDEFINED'">
        </modeso-product-price>
        <div class="add-to-cart">
          <ng-content select="[add-to-cart]"></ng-content>
        </div>
        <!-- <ng-container *ngTemplateOutlet="companyLogoTemplate"></ng-container> -->
      </div>
      <ng-content select="[notification-message]"></ng-content>
    </div>
  </div>
</div>
